import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Ein Symbol, das seine Bedeutung mitbringt: sichtbar als Zeichen, fuer
 * Vorlesehilfen als Text daneben. Beides gehoert zusammen — ein stummes Symbol
 * sagt einer Vorlesehilfe nichts, und ein `title` liest nicht jede zuverlaessig
 * vor.
 *
 * <p>Groesse und Farbe setzt die aufrufende Seite am Wirt; das Zeichen folgt ihr.
 */
@Component({
  selector: 'app-icon-hint',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <mat-icon aria-hidden="true">{{ icon() }}</mat-icon>
    <span class="sr-only">{{ label() }}</span>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex-shrink: 0;
    }

    mat-icon {
      font-size: inherit;
      width: 1em;
      height: 1em;
    }
  `,
})
export class IconHintComponent {
  readonly icon = input.required<string>();
  readonly label = input.required<string>();
}
